import React from 'react';
import {useDispatch} from 'react-redux';
import {toggleActive} from '../store/filters';
import {setActiveFilterCategory} from './../store/app';


// Category state
const checkbox = {
    name: "checkbox",
    buildOptions: function (products) {
        let isOptionArray;
        for (let i = 0; i < products.length; i++) {
            if(!products[i][this.dataPoint]) continue;
            isOptionArray = Array.isArray(products[i][this.dataPoint]); 
            break;
        }
        if (isOptionArray) { 
            products.forEach(product => {
                if (!product[this.dataPoint] || product[this.dataPoint].length <= 0) return;
                product[this.dataPoint].forEach(opName => {
                    this.addOption({name: opName, value: opName, active: false, hasProducts: true});
                })
            })
        } else {
            products.forEach(product => {
                if (!product[this.dataPoint]) return;

                let opName = product[this.dataPoint];
                this.addOption({ name: opName, value: opName, checkboxOrderBy: product[this.checkboxOrderBy], active: false, hasProducts: true});
            })
        }
    },
    element: function() {return (<CheckboxCategory category={this} />)},
    productPassesFilter: function(product) {
        let optionsPassed = [];
        for (let optionIndex = 0; optionIndex < this.options.length; optionIndex++) {
            let option = this.options[optionIndex]
            if (!option.active) continue; // If option isn't active continue to next iteration
            let optionPasses = false;
            if (Array.isArray(product[this.dataPoint])) { // handle dataPointArray
                for (let productOpIndex = 0; productOpIndex < product[this.dataPoint].length; productOpIndex++) {
                    let po = product[this.dataPoint][productOpIndex];
                    if (po === option.value) {
                        optionPasses = true;
                        break;
                    }
                }
            } else { // handle single option
                let po = product[this.dataPoint];
                if (po === option.value) {
                    optionPasses = true;
                }
            }
            optionsPassed.push(optionPasses);
        }
        if (optionsPassed.length > 0 ) {
            if (this.meta.isAnd) return optionsPassed.every(val => val);
            return optionsPassed.some(val => val);
        };
    },
    hasProductsTransform: function(products) {
        this.options.forEach((op, index) => {
            let hasP = false;
            for (let productIndex = 0; productIndex < products.length; productIndex++) {
                let product = products[productIndex];
                if(Array.isArray(product[this.dataPoint])){
                    for (let pDpIndex = 0; pDpIndex < product[this.dataPoint].length; pDpIndex++) {
                        if (product[this.dataPoint][pDpIndex] === op.value) hasP = true;
                        this.options[index].hasProducts = hasP;
                        if (hasP) break;
                    }
                } else {
                    if (product[this.dataPoint] === op.value) {
                        hasP = true;
                    }
                    this.options[index].hasProducts = hasP;
                }
                if (hasP) break;
            }
        })
        return this;
    },
    activeOptionsList: function() {
        let afList = [];
        this.options.forEach(op => {
            if (op.active) afList.push(op.value);
        })
        return afList;
    },
    activeOptionsPills: function() {
        return this.activeOptionsList();
    }
}

// React Element
const CheckboxCategory = ({category}) => {
    let dispatch = useDispatch();
    return (
        category.options.sort((a, b) =>
            category.orderByDirection !== undefined && category.orderByDirection === "desc" ?
                a.checkboxOrderBy !== undefined ?
                    a.checkboxOrderBy < b.checkboxOrderBy ? 1 : -1
                : b.name.localeCompare(a.name)
            :
                a.checkboxOrderBy !== undefined ?
                    a.checkboxOrderBy > b.checkboxOrderBy ? 1 : -1
                : a.name.localeCompare(b.name)
        ).map((option, index) => (
            <label key={index} className={`option ${option.hasProducts ? "" : "disabled"}`}>
                <div className={"checkboxContainer"}>
                    <input 
                        disabled={!option.hasProducts}
                        type="checkbox" 
                        checked={option.active} 
                        name={option.name} 
                        onChange={() => {
                            dispatch(toggleActive(category.dataPoint, option.name));
                            dispatch(setActiveFilterCategory(category.dataPoint));
                        }}
                    />
                    <span className={"checkmark"} />
                </div>
                {option.name}
            </label>
        ))
    )
}

export default checkbox;